<template>
    <div class="dashboard_faculty_square_holder">
        <div class="dashboard_faculty_square_item">
            <div class="dashboard_faculty_item_left">
                <div class="as_link_grey dashboard_faculty_item_name"
                    @click="changeFaculty(faculty_data.faculty_data.id)">
                    {{ faculty_data.faculty_data.acronym }} - {{ faculty_data.faculty_data.name }}
                </div>
                <br><br>
                <div class="deadline_status" :class="deadlineStatus">{{ status_text }}</div>
                <div class="dashboard_faculty_item_progress">
                    Izpolnjeno: {{ faculty_data.faculty_fill_percent }}%
                </div>
                <br><br><br>
                <!-- <div v-show="nextDeadlineTimestamp > 0" class="dashboard_faculty_square_item_deadline">
                    Naslednji rok: {{nextDeadline()}}
                </div> -->
            </div>
        </div>
    </div>
</template>


<script>
import { mapActions } from 'vuex';

export default {
    name: 'SectionsDashboardFacultySquareItem',
    data() {
        return {
            nextDeadlineTimestamp: 0,
            nextDeadlineClosedTimestamp: 0,
            status_text: '',
            nearDeadlineDays: 14
        };
    },
    props: {
        faculty_data: {
            type: Object,
            required: true
        }
    },
    computed: {
        deadlineStatus() {
            const now = Date.now();

            if (!this.faculty_data || !this.faculty_data.faculty_data) return 'preparation';

            if (this.faculty_data.section_submitted_count === this.faculty_data.section_count) return 'filled';

            if (this.nextDeadlineClosedTimestamp > 0 && now > this.nextDeadlineClosedTimestamp) return 'after_late';

            if (this.nextDeadlineTimestamp > 0) {
                if (now > this.nextDeadlineTimestamp) return 'after';
                if (now > this.nextDeadlineTimestamp - this.nearDeadlineDays * 86400000) return 'preparation_late';
            }

            return 'preparation';
        }
    },
    watch: {
        deadlineStatus: {
            immediate: true,
            handler(newVal) {
                if (!this.faculty_data?.faculty_data?.id) return;

                this.status_text = {
                    filled: 'oddano',
                    after_late: 'zamujeno',
                    after: 'zamuda',
                    preparation_late: 'v pripravi',
                    preparation: 'v pripravi'
                }[newVal];

                this.dashboardAddLastStatusByFaculty({
                    id: this.faculty_data.faculty_data.id,
                    status: 'status_' + newVal
                });
            }
        }
    },
    mounted() {
        this.computeDeadlines();
    },
    methods: {
        ...mapActions(['changeFaculty','dashboardAddLastStatusByFaculty']),
        computeDeadlines() {
            const deadlines = Object.values(this.faculty_data.sections || []);
            this.nextDeadlineTimestamp = this.getClosest(deadlines.map(s => s.deadline));
            this.nextDeadlineClosedTimestamp = this.getClosest(deadlines.map(s => s.deadlineClosed));
        },
        getClosest(dates) {
            const valid = dates.filter(d => d && d !== '0000-00-00').map(d => new Date(d).getTime());
            return valid.length ? Math.max(...valid) : 0;
        },
        getDeadline() {
            if (!this.section_data?.deadline || this.section_data.deadline === '0000-00-00') return '';
            const date = new Date(this.section_data.deadline);
            this.deadlineTimestamp = date.getTime();
            return date.toLocaleDateString("sl-SL");
        },

        getDeadlineClosed() {
            if (!this.section_data?.deadlineClosed || this.section_data.deadlineClosed === '0000-00-00') return '';
            const date = new Date(this.section_data.deadlineClosed);
            this.deadlineClosedTimestamp = date.getTime();
            return date.toLocaleDateString("sl-SL");
        },
    }
};
</script>

<style lang="scss" scoped></style>
